import { createActions, createReducer } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedArea } from 'contracts/Areas';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    reset: [],
  },
  { prefix: 'LIST_AREAS_' }
);

export interface ListAreasRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface State {
  data: ListedArea[];
  loading: boolean;
  errorMessage: string | null;
}

const INITIAL_STATE: State = { data: [], loading: false, errorMessage: null };

export const listAreas = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: (state: State) =>
    update(state, {
      loading: { $set: true },
      errorMessage: { $set: null },
    }),
  [Types.SUCCESS]: (state: State, action: { data: ListedArea[] }) =>
    update(state, {
      data: { $set: action.data },
      loading: { $set: false },
    }),
  [Types.FAILURE]: (state: State, action: { errorMessage: string }) =>
    update(state, {
      loading: { $set: false },
      errorMessage: { $set: action.errorMessage },
    }),
  [Types.RESET]: () => INITIAL_STATE,
});

export const ListAreasTypes = Types;
export const ListAreasActions = Creators;
